<template>
  <div class="act_lottery_remain_times" v-html="html">
  </div>
</template>
<script>
  import Vue from 'vue'
  import click_handler from '../../../tools/mgtv/click'
  import to_casher from '../../../tools/mgtv/casher'
  import {openLink} from '../../../tools/mgtv/link'
  import download from '../../../tools/mgtv/downapp'
  import {getJSON} from '../../../api/myaxios'
  import process_award from './process_award'

  export default {
    name: "LotteryRemainTimes",
    props: {
      info: {
        type: Object,
        default:function(){
            return {
              "lotteryRemainTimes": {
                "html":"<div style='font-size:.32rem;color:red'>剩余抽奖次数: $$</div>"
              }
            }
        }
      }
    },
    data(){
      return {}
    },
    computed: {
      remain_times(){
        return window.$bus.lottery.remain_chance
      },
      html(){
        if(this.info.lotteryRemainTimes.html){
          return this.info.lotteryRemainTimes.html.replace(/\$\$/g,this.remain_times)
        }else{
          return this.remain_times;
        }
      }
    },
    methods: {

    },
    created(){

    }

  }
</script>
<style lang="stylus">



</style>





// WEBPACK FOOTER //
// src/components/ConfigUI/Lottery/LotteryRemainTimes.vue